{
  "pricing": {
    "loadingInfo": "Loading pricing information...",
    "noPriceInfo": "No price information available",
    "takeGoldmakingNextLevel": "Take your goldmaking to the next level",
    "subscribeFrom": "Subscribe for just {{price}} {{currency}} / month. No commitment. Cancel anytime.",
    "goldSubActive": "Your current {{type}} subscription runs until {{expiration}}",
    "goldSubTitle": "Gold Subscription Active",
    "goldSubUpgradeTitle": "Ready to go Premium?",
    "goldSubHeading": "Welcome back, goldmaker",
    "goldSubHeadingSubtitle": "Thanks for being a Gold member — here's your subscription at a glance.",
    "upgradeToPremiumContact": "To upgrade to premium please contact our staff in the",
    "discordName": "Flipping Pal Discord",
    "manageBilling": "Manage Billing & Payment Methods",
    "manageBillingOpening": "Opening...",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "saveUpTo": "Save up to {{percent}}% on a yearly subscription.",
    "mostPopular": "Most Popular",
    "perMonth": "/month",
    "perYear": "/year",
    "startDate": "Start Date: {{date}}",
    "nextPaymentDate": "Next payment date: {{date}}",
    "subscriptionEnds": "Subscription ends: {{date}}",
    "reasonPaymentFailed": "Reason: Payment failed",
    "reasonCancelled": "Reason: Cancelled",
    "accessTools": "Access The Tools",
    "resumeSubscription": "Resume Subscription",
    "cancelSubscription": "Cancel Subscription",
    "processing": "Processing...",
    "subscribeNow": "Subscribe now",
    "getStarted": "Get started",
    "switchToMonthly": "Switch to monthly",
    "switchToYearly": "Switch to yearly",
    "upgradeToPremium": "Upgrade to Premium",
    "upgradeLabel": "Upgrade to Premium ({{billing}})",
    "downgradeToBasic": "Downgrade to Basic",
    "downgradeLabel": "Downgrade to Basic ({{billing}})",
    "switchPlan": "Switch Plan",
    "currentPlan": "Current Plan",
    "statusActive": "Active",
    "statusExpired": "Expired",
    "statusCanceled": "Canceled",
    "statusInCancelation": "In cancelation",
    "showMoreFeatures": "+ {{count}} more features",
    "showFewerFeatures": "Show fewer features"
  },
  "trial": {
    "activatedTitle": "Trial Activated!",
    "activatedSubtitle": "Here's what you get — and what's waiting for you",
    "startExploring": "Start Exploring",
    "viewPlans": "View Plans",
    "trialActive": "Free Trial Active",
    "daysRemaining": "{{count}} day remaining",
    "expires": "Expires {{date}}",
    "trialLabel": "Trial",
    "compareButton": "Compare plans",
    "trialEnded": "Your free trial has ended. Subscribe above to keep using FlippingPal!",
    "haveTrialCode": "Have a trial code?",
    "trialCodeHint": "Use",
    "trialCodeHint2": "in our",
    "discordServer": "Discord server",
    "trialCodeHint3": "to get one",
    "activateButton": "Activate Trial",
    "activatingButton": "Activating"
  },
  "features": {
    "basic": {
      "0": "Limited to 10 selling realms",
      "1": "Housing Tool to flip and dropship decor",
      "2": "Cross Realm Flipping Tool",
      "3": "Dropship Tool limited to 3 results per item",
      "4": "Realm Stats",
      "5": "TSM List Generator",
      "6": "Up to 50 item snipe alerts for discord",
      "7": "Filter presets limited to 3",
      "8": "Customer support from the team"
    },
    "premium": {
      "0": "Unlimited selling realms",
      "1": "Housing Tool to flip and dropship decor",
      "2": "Cross Realm Flipping Tool",
      "3": "Dropship Tool increased to 10 results per item",
      "4": "Realm Stats",
      "5": "TSM List Generator",
      "6": "Inventory Analysis Tool",
      "7": "Up to 9999 item snipe alerts for discord",
      "8": "Filter presets limited to 50",
      "9": "Filter sharing with import/export function",
      "10": "Customer support from the team",
      "11": "Priority support"
    }
  },
  "loading": "Loading subscription information..."
}
